import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowOrHideSpinner } from '../../models/showOrHideSpinner';
import { ErrorsService } from '../../services/errors.service';
import { SpinnerService } from '../../services/spinner.service';
import { ScwsApiErrorCodeEnum } from '../../models/scws-api-error-code-enum';
import { ErrorMessages } from '../../models/component-messages/error-messages';

declare var SCWS: any;

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent extends ShowOrHideSpinner implements OnInit, OnDestroy {

  public error: string;
  public errorMessages = new ErrorMessages();

  constructor(private errorsService: ErrorsService,
              private spinnerService: SpinnerService) {
    super();
  }

  ngOnInit() {
    this.hideSpinner(this.spinnerService);

    if (this.errorsService.error.status === 403) {
      this.error = this.errorMessages.errorSecurity;
    } else if (this.errorsService.error.status === 0) {
      this.error = this.errorMessages.errorService;
    } else if (this.errorsService.error.error !== undefined) {
      this.error = this.errorsService.error.error.message;
    } else if (this.errorsService.error instanceof SCWS.Error) {
      if (this.errorsService.error.code === undefined) {
        this.error = this.errorMessages.errorMiddleware;
      } else {
        this.error = ScwsApiErrorCodeEnum[this.errorsService.error.code];
      }
    } else {
      this.error = this.errorMessages.errorContactAdmin;
    }
  }

  ngOnDestroy() {
    this.errorsService.error = null;
  }
}
